import { collection, getDocs, query, where } from 'firebase/firestore';
import { useEffect, useMemo, useState } from 'react';
import { Customer, Customers } from '../../common/Customer';
import { db } from '../../firebase';
import { User } from '../../shared/store';

type ExtendedCustomer = Customer & { id: string };

export const getCustomers = async (user?: User): Promise<Customer[]> => {
  const customers = [] as Customer[];

  if (user) {
    const q = query(
      collection(db, 'customers'),
      where('__name__', 'in', user?.customers),
    );

    const querySnapshot = await getDocs(q);

    querySnapshot.forEach((doc) => {
      customers.push(doc.data() as Customer);
    });
  }

  return customers;
};

export const useCustomers = (user?: User): Customers | undefined => {
  const [customers, setCustomers] = useState<ExtendedCustomer[] | undefined>();

  useEffect(() => {
    const getCustomers = async () => {
      const q = query(
        collection(db, 'customers'),
        where('__name__', 'in', user?.customers),
      );

      const querySnapshot = await getDocs(q);

      const data = [] as ExtendedCustomer[];

      querySnapshot.forEach((doc) => {
        data.push({
          id: doc.id,
          ...doc.data(),
        } as ExtendedCustomer);
      });

      setCustomers(data);
    };

    if (!user) return;

    getCustomers();
  }, [user]);

  return useMemo(
    () =>
      customers
        ? customers.reduce((acc, curr) => ({ ...acc, [curr.id]: curr }), {})
        : undefined,
    [customers],
  );
};
